var GrouponSDSCommon,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

require('./subscriptions_ui.coffee');

GrouponSDSCommon = (function() {
  var COMMON_MOBILE_DISPLAY_EXPERIMENT, NAQ_APP_NAMES, SEO_MOBILE_DISPLAY_EXPERIMENT, TWENTYFOUR_HOURS_LIFE_IN_SECONDS;

  function GrouponSDSCommon() {}

  TWENTYFOUR_HOURS_LIFE_IN_SECONDS = 24 * 60 * 60;

  NAQ_APP_NAMES = ['merchant-page', 'coupon_itier'];

  COMMON_MOBILE_DISPLAY_EXPERIMENT = "subscription-flow-mobile-show-experiment";

  SEO_MOBILE_DISPLAY_EXPERIMENT = "subscription-flow-mobile-seo-show-experiment";

  GrouponSDSCommon.log = function(title, info) {
    if (info == null) {
      info = {};
    }
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null) {
      if (info['goalType'] == null) {
        info['goalType'] = 'subscription';
      }
      if (info['uiSource'] == null) {
        info['uiSource'] = "sds";
      }
      try {
        return OptimizeSuite.TrackingHub.add(title, info);
      } catch (error) {
        return null;
      }
    }
  };

  GrouponSDSCommon.dismissModal = function(container) {
    if (container != null) {
      if (typeof container.hide === "function") {
        container.hide();
      }
      if (typeof container.hideSpotlight === "function") {
        container.hideSpotlight();
      }
      return $('#global-container').show();
    }
  };

  GrouponSDSCommon.getAppName = function() {
    var ref, ref1;
    if (($('head').attr('data-app') != null) && $('head').attr('data-app').length > 0) {
      return encodeURIComponent($('head').attr('data-app'));
    } else if (((typeof Optimize !== "undefined" && Optimize !== null ? (ref = Optimize.suiteData) != null ? ref.app : void 0 : void 0) != null) && (typeof Optimize !== "undefined" && Optimize !== null ? (ref1 = Optimize.suiteData) != null ? ref1.app.length : void 0 : void 0) > 0) {
      return encodeURIComponent(Optimize.suiteData.app);
    }
  };

  GrouponSDSCommon.showSuccessNotification = function() {
    if ($('#email_subscription_subanner').length > 0) {
      $('#email_subscription_subanner').show();
      $('#email_subscription_subanner').click(function() {
        return $('#email_subscription_subanner').slideUp(2000);
      });
    }
    if ($('#notice_banner').length > 0) {
      $('#notice_banner').show();
    }
  };

  GrouponSDSCommon.gtmSubscribeEvent = function() {
    return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
      'event': 'subscription'
    }) : void 0;
  };

  GrouponSDSCommon.gtmSubscribeLandingEvent = function(subsave) {
    if (subsave == null) {
      subsave = false;
    }
    if (subsave) {
      return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
        'event': 'subscription/save'
      }) : void 0;
    } else {
      return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
        'event': 'subscription/landing'
      }) : void 0;
    }
  };

  GrouponSDSCommon.isSubForced = function() {
    var ref, ref1;
    return (typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? (ref1 = ref.href) != null ? ref1.indexOf('subs_force=') : void 0 : void 0 : void 0) > -1;
  };

  GrouponSDSCommon.fpBasedShow = function(fpShowFn, fpHideFn) {
    var fpCookie, fpHide;
    fpCookie = Cookie.get('subs_fp_hide');
    if (fpCookie == null) {
      return fpShowFn();
    }
    Cookie.unset('subs_fp_hide', $('head').data('domain'));
    fpHide = fpCookie === '1';
    if (fpHide) {
      Cookie.set('hide_sub_modal', 1);
      fpHideFn();
    } else {
      fpShowFn();
    }
    return GrouponSDSCommon.log('subscriptionFpHide', {
      fpHide: fpHide
    });
  };

  GrouponSDSCommon.isEmailClickTraffic = function() {
    var ref, utm_medium;
    if ((typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? ref.href : void 0 : void 0) != null) {
      utm_medium = new RegExp('[\\?&]utm_medium=([^&#]*)').exec(window.location.href);
    }
    if (((utm_medium != null) && (utm_medium[1] != null) && utm_medium[1].toLowerCase() === 'email') || ((typeof Cookie !== "undefined" && Cookie !== null) && Cookie.get('_tpmed') === 'email')) {
      return true;
    } else {
      return false;
    }
  };

  GrouponSDSCommon.isMobileSeoSkippingTraffic = function(url) {
    var appName, isSemTraffic, isTouchTraffic, mobileHideModal, ref, ref1, ref2, ref3;
    if (url == null) {
      url = window.location.href;
    }
    isSemTraffic = url.indexOf('utm_source') > -1 || url.indexOf('utm_campaign') > -1 || url.indexOf('utm_medium') > -1;
    isTouchTraffic = (ref = typeof TrackingHub !== "undefined" && TrackingHub !== null ? (ref1 = TrackingHub.user) != null ? (ref2 = ref1.deviceType) != null ? ref2.toLowerCase() : void 0 : void 0 : void 0) === 'mobile' || ref === 'tablet';
    if (isSemTraffic || !isTouchTraffic) {
      return false;
    }
    appName = (ref3 = GrouponSDSCommon.getAppName()) != null ? ref3.toLowerCase() : void 0;
    mobileHideModal = appName === 'seo-platform-itier' || appName === 'merchant-page';
    return mobileHideModal;
  };

  GrouponSDSCommon.isMobileSkippingTraffic = function() {
    var appName, mobileHideModal, ref, ref1, ref2;
    if ((typeof TrackingHub !== "undefined" && TrackingHub !== null ? (ref = TrackingHub.user) != null ? (ref1 = ref.deviceType) != null ? ref1.toLowerCase() : void 0 : void 0 : void 0) !== 'mobile') {
      return false;
    }
    mobileHideModal = false;
    appName = (ref2 = GrouponSDSCommon.getAppName()) != null ? ref2.toLowerCase() : void 0;
    if (appName === 'seo-platform-itier' || appName === 'gsm-ita') {
      if (typeof Finch !== "undefined" && Finch !== null) {
        if (typeof Finch.experiment === "function") {
          Finch.experiment(SEO_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile: function() {
              return mobileHideModal = true;
            },
            showForMobile: function() {
              return mobileHideModal = false;
            }
          });
        }
      }
    } else {
      if (typeof Finch !== "undefined" && Finch !== null) {
        if (typeof Finch.experiment === "function") {
          Finch.experiment(COMMON_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile: function() {
              return mobileHideModal = true;
            },
            showForMobile: function() {
              return mobileHideModal = false;
            }
          });
        }
      }
    }
    return mobileHideModal;
  };

  GrouponSDSCommon.isNAQTraffic = function(url) {
    var appName, entries, ref, ref1, utm_campaign;
    if (url == null) {
      url = window.location.href;
    }
    appName = (ref = GrouponSDSCommon.getAppName()) != null ? ref.toLowerCase() : void 0;
    utm_campaign = new RegExp('[\\?&]utm_campaign=([^&#]*)').exec(url);
    if (indexOf.call(NAQ_APP_NAMES, appName) >= 0 && ((utm_campaign != null ? utm_campaign[1] : void 0) != null)) {
      entries = utm_campaign[1].split("_");
      if (((ref1 = entries[5]) != null ? ref1.toLowerCase() : void 0) === "naq") {
        return true;
      }
    }
    return false;
  };

  GrouponSDSCommon.isSkippingTraffic = function(url) {
    var countryDomain, result;
    if (url == null) {
      url = window.location.href;
    }
    countryDomain = $('head').data('domain') || '';
    result = GrouponSDSCommon.isMobileSkippingTraffic();
    if (result && (typeof Cookie !== "undefined" && Cookie !== null)) {
      Cookie.set("hide_sub_modal", 1, TWENTYFOUR_HOURS_LIFE_IN_SECONDS, countryDomain);
    }
    return result;
  };

  GrouponSDSCommon.setupSuccessCallback = function() {
    var appName, previousDivision, ref;
    previousDivision = typeof Cookie !== "undefined" && Cookie !== null ? Cookie.get('division') : void 0;
    appName = (ref = GrouponSDSCommon.getAppName()) != null ? ref.toLowerCase() : void 0;
    if (appName === 'pull') {
      return window._subscriptionSuccessCallback = function(divisionId, postalCode) {
        var ref1;
        GrouponSDSCommon.gtmSubscribeEvent();
        if (!((ref1 = window.SubscriptionsUI) != null ? ref1._should_show_doi() : void 0) && previousDivision !== divisionId) {
          return window.location = "/browse/" + divisionId + "?post_subscribe=true";
        } else {
          return GrouponSDSCommon.showSuccessNotification();
        }
      };
    } else {
      return window._subscriptionSuccessCallback = function() {
        GrouponSDSCommon.gtmSubscribeEvent();
        return GrouponSDSCommon.showSuccessNotification();
      };
    }
  };

  return GrouponSDSCommon;

})();

window.GrouponSDSCommon = GrouponSDSCommon;

window._useSDS = true;

//# sourceMappingURL=data:application/json;base64,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
